var GrouponSDSCommon,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

require('./subscriptions_ui.coffee');

GrouponSDSCommon = (function() {
  var COMMON_MOBILE_DISPLAY_EXPERIMENT, NAQ_APP_NAMES, SEO_MOBILE_DISPLAY_EXPERIMENT, TWENTYFOUR_HOURS_LIFE_IN_SECONDS;

  function GrouponSDSCommon() {}

  TWENTYFOUR_HOURS_LIFE_IN_SECONDS = 24 * 60 * 60;

  NAQ_APP_NAMES = ['merchant-page', 'coupon_itier'];

  COMMON_MOBILE_DISPLAY_EXPERIMENT = "subscription-flow-mobile-show-experiment";

  SEO_MOBILE_DISPLAY_EXPERIMENT = "subscription-flow-mobile-seo-show-experiment";

  GrouponSDSCommon.log = function(title, info) {
    if (info == null) {
      info = {};
    }
    if ((typeof OptimizeSuite !== "undefined" && OptimizeSuite !== null ? OptimizeSuite.TrackingHub : void 0) != null) {
      if (info['goalType'] == null) {
        info['goalType'] = 'subscription';
      }
      if (info['uiSource'] == null) {
        info['uiSource'] = "sds";
      }
      try {
        return OptimizeSuite.TrackingHub.add(title, info);
      } catch (error) {
        return null;
      }
    }
  };

  GrouponSDSCommon.dismissModal = function(container) {
    if (container != null) {
      if (typeof container.hide === "function") {
        container.hide();
      }
      if (typeof container.hideSpotlight === "function") {
        container.hideSpotlight();
      }
      return $('#global-container').show();
    }
  };

  GrouponSDSCommon.getAppName = function() {
    var ref, ref1;
    if (($('head').attr('data-app') != null) && $('head').attr('data-app').length > 0) {
      return encodeURIComponent($('head').attr('data-app'));
    } else if (((typeof Optimize !== "undefined" && Optimize !== null ? (ref = Optimize.suiteData) != null ? ref.app : void 0 : void 0) != null) && (typeof Optimize !== "undefined" && Optimize !== null ? (ref1 = Optimize.suiteData) != null ? ref1.app.length : void 0 : void 0) > 0) {
      return encodeURIComponent(Optimize.suiteData.app);
    }
  };

  GrouponSDSCommon.showSuccessNotification = function() {
    if ($('#email_subscription_subanner').length > 0) {
      $('#email_subscription_subanner').show();
      $('#email_subscription_subanner').click(function() {
        return $('#email_subscription_subanner').slideUp(2000);
      });
    }
    if ($('#notice_banner').length > 0) {
      $('#notice_banner').show();
    }
  };

  GrouponSDSCommon.gtmSubscribeEvent = function() {
    return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
      'event': 'subscription'
    }) : void 0;
  };

  GrouponSDSCommon.gtmSubscribeLandingEvent = function(subsave) {
    if (subsave == null) {
      subsave = false;
    }
    if (subsave) {
      return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
        'event': 'subscription/save'
      }) : void 0;
    } else {
      return typeof dataLayer !== "undefined" && dataLayer !== null ? dataLayer.push({
        'event': 'subscription/landing'
      }) : void 0;
    }
  };

  GrouponSDSCommon.isSubForced = function() {
    var ref, ref1;
    return (typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? (ref1 = ref.href) != null ? ref1.indexOf('subs_force=') : void 0 : void 0 : void 0) > -1;
  };

  GrouponSDSCommon.fpBasedShow = function(fpShowFn, fpHideFn) {
    var fpCookie, fpHide;
    fpCookie = Cookie.get('subs_fp_hide');
    if (fpCookie == null) {
      return fpShowFn();
    }
    Cookie.unset('subs_fp_hide', $('head').data('domain'));
    fpHide = fpCookie === '1';
    if (fpHide) {
      Cookie.set('hide_sub_modal', 1);
      fpHideFn();
    } else {
      fpShowFn();
    }
    return GrouponSDSCommon.log('subscriptionFpHide', {
      fpHide: fpHide
    });
  };

  GrouponSDSCommon.isEmailClickTraffic = function() {
    var ref, utm_medium;
    if ((typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? ref.href : void 0 : void 0) != null) {
      utm_medium = new RegExp('[\\?&]utm_medium=([^&#]*)').exec(window.location.href);
    }
    if (((utm_medium != null) && (utm_medium[1] != null) && utm_medium[1].toLowerCase() === 'email') || ((typeof Cookie !== "undefined" && Cookie !== null) && Cookie.get('_tpmed') === 'email')) {
      return true;
    } else {
      return false;
    }
  };

  GrouponSDSCommon.isMobileSeoSkippingTraffic = function(url) {
    var appName, isSemTraffic, isTouchTraffic, mobileHideModal, ref, ref1, ref2, ref3;
    if (url == null) {
      url = window.location.href;
    }
    isSemTraffic = url.indexOf('utm_source') > -1 || url.indexOf('utm_campaign') > -1 || url.indexOf('utm_medium') > -1;
    isTouchTraffic = (ref = typeof TrackingHub !== "undefined" && TrackingHub !== null ? (ref1 = TrackingHub.user) != null ? (ref2 = ref1.deviceType) != null ? ref2.toLowerCase() : void 0 : void 0 : void 0) === 'mobile' || ref === 'tablet';
    if (isSemTraffic || !isTouchTraffic) {
      return false;
    }
    appName = (ref3 = GrouponSDSCommon.getAppName()) != null ? ref3.toLowerCase() : void 0;
    mobileHideModal = appName === 'seo-platform-itier' || appName === 'merchant-page';
    return mobileHideModal;
  };

  GrouponSDSCommon.isMobileSkippingTraffic = function() {
    var appName, mobileHideModal, ref, ref1, ref2;
    if ((typeof TrackingHub !== "undefined" && TrackingHub !== null ? (ref = TrackingHub.user) != null ? (ref1 = ref.deviceType) != null ? ref1.toLowerCase() : void 0 : void 0 : void 0) !== 'mobile') {
      return false;
    }
    mobileHideModal = false;
    appName = (ref2 = GrouponSDSCommon.getAppName()) != null ? ref2.toLowerCase() : void 0;
    if (appName === 'seo-platform-itier' || appName === 'gsm-ita') {
      if (typeof Finch !== "undefined" && Finch !== null) {
        if (typeof Finch.experiment === "function") {
          Finch.experiment(SEO_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile: function() {
              return mobileHideModal = true;
            },
            showForMobile: function() {
              return mobileHideModal = false;
            }
          });
        }
      }
    } else {
      if (typeof Finch !== "undefined" && Finch !== null) {
        if (typeof Finch.experiment === "function") {
          Finch.experiment(COMMON_MOBILE_DISPLAY_EXPERIMENT, {
            hideForMobile: function() {
              return mobileHideModal = true;
            },
            showForMobile: function() {
              return mobileHideModal = false;
            }
          });
        }
      }
    }
    return mobileHideModal;
  };

  GrouponSDSCommon.isNAQTraffic = function(url) {
    var appName, entries, ref, ref1, utm_campaign;
    if (url == null) {
      url = window.location.href;
    }
    appName = (ref = GrouponSDSCommon.getAppName()) != null ? ref.toLowerCase() : void 0;
    utm_campaign = new RegExp('[\\?&]utm_campaign=([^&#]*)').exec(url);
    if (indexOf.call(NAQ_APP_NAMES, appName) >= 0 && ((utm_campaign != null ? utm_campaign[1] : void 0) != null)) {
      entries = utm_campaign[1].split("_");
      if (((ref1 = entries[5]) != null ? ref1.toLowerCase() : void 0) === "naq") {
        return true;
      }
    }
    return false;
  };

  GrouponSDSCommon.isSkippingTraffic = function(url) {
    var countryDomain, result;
    if (url == null) {
      url = window.location.href;
    }
    countryDomain = $('head').data('domain') || '';
    result = GrouponSDSCommon.isMobileSkippingTraffic();
    if (result && (typeof Cookie !== "undefined" && Cookie !== null)) {
      Cookie.set("hide_sub_modal", 1, TWENTYFOUR_HOURS_LIFE_IN_SECONDS, countryDomain);
    }
    return result;
  };

  GrouponSDSCommon.setupSuccessCallback = function() {
    var appName, previousDivision, ref;
    previousDivision = typeof Cookie !== "undefined" && Cookie !== null ? Cookie.get('division') : void 0;
    appName = (ref = GrouponSDSCommon.getAppName()) != null ? ref.toLowerCase() : void 0;
    if (appName === 'pull') {
      return window._subscriptionSuccessCallback = function(divisionId, postalCode) {
        var ref1;
        GrouponSDSCommon.gtmSubscribeEvent();
        if (!((ref1 = window.SubscriptionsUI) != null ? ref1._should_show_doi() : void 0) && previousDivision !== divisionId) {
          return window.location = "/browse/" + divisionId + "?post_subscribe=true";
        } else {
          return GrouponSDSCommon.showSuccessNotification();
        }
      };
    } else {
      return window._subscriptionSuccessCallback = function() {
        GrouponSDSCommon.gtmSubscribeEvent();
        return GrouponSDSCommon.showSuccessNotification();
      };
    }
  };

  return GrouponSDSCommon;

})();

window.GrouponSDSCommon = GrouponSDSCommon;

window._useSDS = true;

//# sourceMappingURL=data:application/json;base64,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
